import { Button } from "@mui/material";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";

import MaterialSubcategoryForm from "components/form/MaterialSubcategoryForm";

import { SaveContextProvider } from "context/save";

import { useMaterialSubcategoryId } from "hooks/useId";
import useSaveUpdateWithSnackbar from "hooks/useSaveUpdateWithSnackbar";

function ButtonSave() {
    const { onButtonClick } = useSaveUpdateWithSnackbar({
        successMsg: "Sottocategoria modificata con successo",
        errorMsg: "Errore nella modifica della sottocategoria",
        navigateTo: { link: "/gestione-materiali/sotto-categorie" }
    });

    return (
        <GridItem>
            <GridRow justifyContent={"right"}>
                <GridItem>
                    <Button variant={"contained"} onClick={onButtonClick}>
                        Salva
                    </Button>
                </GridItem>
            </GridRow>
        </GridItem>
    );
}

function ModificaSottoCatMateriale() {
    const materialSubcategoryId = useMaterialSubcategoryId();

    return (
        <GridColumn>
            <SaveContextProvider>
                <GridRow justifyContent={"space-between"} alignItems={"end"}>
                    <GridItem>
                        <GridRow>
                            <GridItem>
                                <h1>Modifica Sottocategoria Materiale</h1>
                            </GridItem>
                        </GridRow>
                    </GridItem>

                    <GridItem>
                        <ButtonSave />
                    </GridItem>
                </GridRow>

                <MaterialSubcategoryForm materialSubcategoryId={materialSubcategoryId} />
            </SaveContextProvider>
        </GridColumn>
    );
}

export default ModificaSottoCatMateriale;
